export function trackViewItem( product ) {
	const viewedProduct = {
		currency: "USD",
		value: product.variants[0].priceRec,
		items: [
			{
				item_id: product.id,
				item_name: product.name,
				item_brand: product.brand ? product.brand.name : "",
				item_category: product.category,
				price: product.variants[0].priceRec,
				quantity: 1,
			},
		],
	};

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(
		{
			event: 'view_item',
			ecommerce: {
				...viewedProduct
			},
		}
	);
}

export function trackAddToCart({ product, quantity, price, specialPrice, weight, retailerName, retailerId, checkout }) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(
		{
			event: 'add_to_cart',
			ecommerce: {
				currency: "USD",
				value: specialPrice ? specialPrice * quantity : price * quantity,
				items: [
					{
						item_id: product.id,
						item_name: product.name,
						affiliation: retailerName,
						...(product.coupon && { coupon: product.coupon }),
						...(product.promotion_id && { promotion_id: product.promotion_id }),
						...(product.promotion_name && { promotion_name: product.promotion_name }),
						discount: specialPrice ? price - specialPrice : 0,
						index: checkout.items.length,
						item_brand: product.brand?.name,
						item_category: product.category,
						item_variant: weight ? weight.option : product.variants[0].option,
						location_id: retailerId,
						price: specialPrice ? specialPrice : price,
						quantity,
					},
				],
			}
		}
	);


	if ( product.promotion_id ) {
		sessionStorage.setItem(`cp_promo_item_${product.id}`, JSON.stringify({
			promotion_id: product.promotion_id,
			promotion_name: product.promotion_name,
		}));
	}
}

export function trackRemoveFromCart( cartItem, index ) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(
		{
			event: 'remove_from_cart',
			ecommerce: {
				currency: "USD",
				value: cartItem.product.variants[0].priceRec * cartItem.quantity,
				items: [
					{
						item_id: cartItem.id,
						item_name: cartItem.product.name,
						item_brand: cartItem.product.brand ? cartItem.product.brand.name : "",
						item_category: cartItem.product.category,
						index,
						quantity: cartItem.quantity,
						price: cartItem.product.variants[0].priceRec,
					}
				]
			}
		}
	);
}

export function trackBeginCheckout( trackedItems ) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(
		{
			event: 'begin_checkout',
			ecommerce: {
				...trackedItems
			}
		}
	);
}

export function trackPurchase( purchase ) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(
		{
			event: 'purchase',
			ecommerce: {
				...purchase
			},
		}
	);
}


export function trackPromoView( special, items, retailerId ) {
	if ( ! special ) {
		return;
	}

	let formattedItem = formatPromotionItems( items ? items : null, special, retailerId);

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(
		{
			event: 'view_promotion',
			ecommerce: {
				creative_name: special.name,
				creative_slot: "Specials Slider",
				promotion_id: special.id,
				promotion_name: special.name,
				...formattedItem && { items: formattedItem }
			},
		}
	);
}

export function trackPromoSelect( special, item, retailerId ) {
	if ( ! special ) {
		return;
	}

	let formattedItem = formatPromotionItems( item ? item : null , special, retailerId);
	
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(
		{
			event: 'select_promotion',
			ecommerce: {
				creative_name: special.name,
				creative_slot: "Specials Slider",
				promotion_id: special.id,
				promotion_name: special.name,
				...formattedItem && { items: formattedItem }
			},
		}
	);
}

export function formatPromotionItems( items, special, retailerId ) {
	if ( ! items || items.length === 0 ) {
		return;
	}

	let retailerName = localStorage.getItem('cp_retailer_name');
	
	let formattedItems = items.map(( item, index ) => ({
		item_id: item.id,
		item_name: item.name,
		affiliation: retailerName,
		coupon: special.id,
		discount: item.variants[0].specialPriceRec ? item.variants[0].priceRec - item.variants[0].specialPriceRec : 0,
		index,
		item_brand: item.brand ? item.brand.name : "",
		item_category: item.category,
		item_list_id: "specials-slider",
		item_list_name: "Specials Slider",
		item_variant: item.variants[0].option,
		location_id: retailerId,
		price: item.variants[0].priceRec,
		quantity: item.quantity ?? 1,
		promotion_id: special.id,
		promotion_name: special.name,
	}));
	
	return formattedItems;
}